import React, { memo } from 'react';
import PropTypes from 'prop-types';
import style from '../../style/components/profile/WalletAlert.module.scss';

const VARIANT_ICONS = {
  warning: 'alert-triangle',
  error: 'alert-circle',
  info: 'info',
};

const WalletAlert = ({ variant, icon, children, onDismiss, dismissLabel }) => {
  const iconName = icon || VARIANT_ICONS[variant] || VARIANT_ICONS.info;
  const role =
    variant === 'warning' || variant === 'error' ? 'alert' : undefined;

  return (
    <div
      className={`${style.alert} ${style[variant] || style.info}`}
      role={role}
    >
      <idme-icon name={iconName} size="small" />
      <div className={style.content}>{children}</div>
      {onDismiss && (
        <button
          type="button"
          className={style.dismiss}
          onClick={onDismiss}
          aria-label={dismissLabel}
        >
          <idme-icon name="close" size="small" />
        </button>
      )}
    </div>
  );
};

WalletAlert.propTypes = {
  variant: PropTypes.oneOf(['warning', 'error', 'info']),
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
  onDismiss: PropTypes.func,
  dismissLabel: PropTypes.string,
};

WalletAlert.defaultProps = {
  variant: 'info',
  dismissLabel: 'Dismiss',
};

export default memo(WalletAlert);
